"use client";

import { motion } from "motion/react";
import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { AnimateProps } from "../types";
import { getVariant } from "../variants";

function AnimateItem<T extends React.ElementType = "div">({
  as,
  asChild = false,
  variant = "fadeIn",
  className,
  ...props
}: AnimateProps<T>) {
  const Component = motion.create(resolveElement(asChild, as, "div"));
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Animate.Item] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(className, classes)}
      {...getVariant(variant)}
      {...native}
    />
  );
}

AnimateItem.displayName = "Animate.Item";

export default AnimateItem;
